import React, { Component } from 'react';
import { Icon, List, Toast ,Modal} from 'antd-mobile';
import * as services from '../projects/services';
import { CommonlyHead } from '../common/headnav';
import { HospitalItems } from '../hospital/item';
import { createBrowserHistory } from "history";
import './style.less';
const history = createBrowserHistory();
const alert = Modal.alert;
const Item = List.Item;
export default class IntegralTransfer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardList: [],
            resultPrice: 0,
            hospitalData: [],
        }
    }
    componentDidMount() {
        let parameter = { page: 1, rows: 100 };
        services.GetUserCardList(parameter, '').then((data) => {
            if (data.status === 0) {
                let cardList = [];
                let resultPrice = 0;
                if (!!data.result.rows) {
                    data.result.rows.forEach((item) => {
                        if (!!item.isDestination === false) {
                            item.show = true;
                            resultPrice += parseFloat(item.cardMoney);
                            cardList.push(item);
                        }

                    })
                }

                this.setState({ cardList: cardList, resultPrice: parseFloat(resultPrice).toFixed(2) });
            } else {
                Toast.offline(data.message);
            }
        });
        services.GetHospitalDetails('057498', '').then((data) => {
            if (data.status === 0) {
                this.setState({ hospitalData: data.result });
            } else {
            }
        })
    }
    Insertorder = () => {
        let m_user = '';
        if (!!localStorage.getItem('QUANREN_SSO_MM_USER_CACHE')) {
            m_user = JSON.parse(localStorage.getItem('QUANREN_SSO_MM_USER_CACHE'));
            let parameter = [];
            this.state.cardList.forEach((item) => {
                if (!!item.show) {
                    let data = {
                        password: '-1',
                        spendMoney: item.cardMoney,
                        userId: m_user.userid,
                        userName: m_user.fullname,
                        cardCode: item.cardCode,
                        source: '5',
                        spendId: '057497'
                    };
                    parameter.push(data);
                }
            })         
            if (parameter.length > 0) {
                services.Insertorder(parameter, '正在转移，请稍后').then(data => {
                    if (data.status === 0) {
                        history.push('/public-result/integraltransfer/' + data.status);
                        history.go();
                    } else {
                        Toast.offline('转移失败！');
                    }
                })
            }else{
                Toast.offline('您没有需要转移的积分!');
            }

        }

    }
    onClick = (data, e) => {
        let cardList = this.state.cardList;
        let resultPrice = 0;
        cardList.forEach(function
            (item) {
            if (item.publicId === data.publicId) {
                item.show = !item.show;
            }
            if (item.show === true) {
                resultPrice += parseFloat(item.cardMoney);
            }
        })
        this.setState({ cardList: cardList, resultPrice: parseFloat(resultPrice).toFixed(2) });
    }
    render() {
        const { cardList, hospitalData } = this.state;

        return <div className="integralTransfer" >
            <CommonlyHead barname={'全人健康'} />

            <List renderHeader={() => '健康积分（默认选中）'}>
                {
                    cardList.length === 0 ? '' :
                        cardList.map((data, index) => (
                            <Item key={index} onClick={this.onClick.bind(this, data)}>
                                <div className="flexdiv"><img alt="" className="zsvg" src={require('../../res/images/logo.png')} /><span className="title">{data.cardCode}<span className="coloro">(积分：{data.cardMoney} )</span></span><Icon className="checkico" style={{ fill: data.show === true ? '#32a128' : '#cccccc' }} type={data.show === true ? 'check-circle' : 'check-circle-o'} />
                                </div>
                            </Item>
                        ))
                }
                <Item>合计健康积分：<span className="resultPrice">{this.state.resultPrice}</span></Item>

                {
                    hospitalData !== null ?
                        <div className="hospitalItems">
                            <HospitalItems hospitalData={hospitalData} index={1} /></div>
                        : ''
                }
            </List>
            <div className="buts">
                <button className="but" onClick=
                 {() =>
                    alert('积分转移提示', '您确定转移'+this.state.resultPrice+'的积分至指定体检中心吗?', [
                        { text: '取消', onPress: () => console.log('cancel') },
                        { text: '确定转移', onPress: () => this.Insertorder() },
                    ])
                }             
                
                >确定转移</button>
            </div>
            <div className="transfertips">
                根据近期多家单位集中出现的由于体检期限到期、体检中心接待繁忙造成的问题，全人健康平台与江北彰基体检中心达成合作，
                同意客户即将过期的实体卡及平台积分转化为体检中心可消费余额，余额可在该体检中心自由消费，有效期一年。<br></br>如有疑问，请联系客服：0574-89119527
            </div>

        </div>;
    }
}